import React, { Fragment } from 'react';
import SettingsContainer from './SettingsContainer';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import HeaderPortal from 'components/layout/HeaderPortal';

const Route = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.header)}></Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}></Portal>
      <SettingsContainer />
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
